import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useState, useEffect } from "react";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { setCacheUser, clearCache } from "./lib/clientCache";



const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

if (process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
  // eslint-disable-next-line
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
}
// eslint-disable-next-line
const analytics = getAnalytics(app);

const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),

  // Optional argument. If true, the SDK automatically refreshes App Check
  // tokens as needed.
  isTokenAutoRefreshEnabled: true
});
// eslint-disable-next-line
const functions = getFunctions(app);


export const auth = getAuth(app);

// Keep the client cache scoped to the signed-in user, and wipe it on
// sign-out (from any logout button, token revocation or expiry) so cached
// holdings and transactions don't outlive the session on a shared device.
onAuthStateChanged(auth, (user) => {
  setCacheUser(user?.uid);
  if (!user) clearCache();
});

export function useAuth(){
  const [currentUser, setCurrentUser] = useState();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, user =>  setCurrentUser(user));
    return unsub;
  }, []) 

  return currentUser;
}

export default appCheck;